/** Shared skill display metadata — used by SkillMarketPage and SkillsPanel */

export const SKILL_NAMES_ZH: Record<string, string> = {
  nuwa: '女娲 · Skill造人术',
  'web-design-engineer': 'Web 设计工程师',
  'web-video-presentation': '演示文稿制作',
  'gpt-image-2': 'AI 图像生成',
  'steve-jobs-perspective': '乔布斯思维',
  'munger-perspective': '芒格思维',
  'paul-graham-perspective': 'PG 思维',
  'elon-musk-perspective': '马斯克思维',
  'feynman-perspective': '费曼思维',
  consultant: '咨询顾问框架',
  'contract-review': '合同审查助手',
  'grc-compliance': 'GRC 合规审计',
  'auto-body-tester': '车身域测试工程师',
  'steam-gaming-assistant': 'Steam 游戏管家',
  'ai-news': 'AI 资讯聚合',
  'app-store-release': 'App Store 审核上架',
};

export const SKILL_ICONS: Record<string, string> = {
  nuwa: '🧬',
  metaschedule: '⏰',
  'skill-hub': '🏪',
  metaskill: '🧬',
  novax: '🤖',
  'web-design-engineer': '🎨',
  'web-video-presentation': '🎬',
  'gpt-image-2': '🖼️',
  'steve-jobs-perspective': '🍎',
  'munger-perspective': '📊',
  'paul-graham-perspective': '✍️',
  'elon-musk-perspective': '🚀',
  'feynman-perspective': '🔬',
  consultant: '💼',
  'contract-review': '📜',
  'grc-compliance': '🛡️',
  'auto-body-tester': '🚗',
  'steam-gaming-assistant': '🎮',
  'ai-news': '📰',
  'app-store-release': '📱',
};

/** Cover image URL per skill — set to actual image paths when available */
export const SKILL_COVERS: Record<string, string> = {
  nuwa: '/avatars/skill-covers/nuwa.jpg',
  'web-design-engineer': '/avatars/skill-covers/web-design-engineer.jpg',
  'web-video-presentation': '/avatars/skill-covers/web-video-presentation.jpg',
  'gpt-image-2': '/avatars/skill-covers/gpt-image-2.jpg',
  'steve-jobs-perspective': '/avatars/skill-covers/steve-jobs.jpg',
  'munger-perspective': '/avatars/skill-covers/charlie-munger.jpg',
  'paul-graham-perspective': '/avatars/skill-covers/paul-graham.jpg',
  'elon-musk-perspective': '/avatars/skill-covers/elon-musk.jpg',
  'feynman-perspective': '/avatars/skill-covers/feynman.jpg',
  consultant: '/avatars/skill-covers/consultant.jpg',
  'contract-review': '/avatars/skill-covers/contract-review.jpg',
  'grc-compliance': '/avatars/skill-covers/grc-compliance.jpg',
  'auto-body-tester': '/avatars/skill-covers/auto-body-tester.jpg',
  'steam-gaming-assistant': '/avatars/skill-covers/steam.jpg',
  'ai-news': '/avatars/skill-covers/ai-news.jpg',
  'app-store-release': '/avatars/skill-covers/app-store-release.jpg',
};

/** Short category label shown on the card cover */
export const SKILL_CATEGORY_LABELS: Record<string, string> = {
  nuwa: '系统工具',
  'web-design-engineer': '设计创作',
  'web-video-presentation': '设计创作',
  'gpt-image-2': '设计创作',
  'steve-jobs-perspective': '思维框架',
  'munger-perspective': '思维框架',
  'paul-graham-perspective': '思维框架',
  'elon-musk-perspective': '思维框架',
  'feynman-perspective': '思维框架',
  consultant: '商业咨询',
  'contract-review': '法律工具',
  'grc-compliance': '合规审计',
  'auto-body-tester': '汽车工程',
  'steam-gaming-assistant': '游戏娱乐',
  'ai-news': '信息研究',
  'app-store-release': '移动开发',
};

/** Accent color per skill for the cover area */
export const SKILL_ACCENT_COLORS: Record<string, string> = {
  nuwa: '#9ddf7e',
  'web-design-engineer': '#e34a2a',
  'web-video-presentation': '#ffb56b',
  'gpt-image-2': '#c084fc',
  'steve-jobs-perspective': '#f87171',
  'munger-perspective': '#e34a2a',
  'paul-graham-perspective': '#9ddf7e',
  'elon-musk-perspective': '#60a5fa',
  'feynman-perspective': '#fbbf24',
  consultant: '#3b82f6',
  'contract-review': '#f59e0b',
  'grc-compliance': '#10b981',
  'auto-body-tester': '#14b8a6',
  'steam-gaming-assistant': '#1b2838',
  'ai-news': '#1e3a5f',
  'app-store-release': '#5856d6',
};

export function getSkillDisplayName(name: string): string {
  return SKILL_NAMES_ZH[name] || name;
}

export function getSkillIcon(name: string): string {
  return SKILL_ICONS[name] || '⚡';
}

export function getSkillCover(name: string): string | undefined {
  return SKILL_COVERS[name];
}

export function getSkillCategoryLabel(name: string): string {
  return SKILL_CATEGORY_LABELS[name] || '';
}

export function getSkillAccentColor(name: string): string {
  return SKILL_ACCENT_COLORS[name] || '#9ddf7e';
}
